import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
    addApiKeyForm: {
        display: 'flex',
        flexDirection: 'column',
    },
});
